export default __webpack_public_path__ + "ea3167f910c8486d4628438ed5faf97f.svg";